module.exports = __webpack_public_path__ + "img/instagram.9bc59c7e.svg";